module.exports = __webpack_public_path__ + "img/p-banner-208.7e30cf85.png";